exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-line[data-v-b788aed4] {\n  display: inline;\n}\n", ""]);

// exports
